module.exports = __webpack_public_path__ + "img/404.c95eb265.png";